export const isScrollbarClicked = (e): boolean => {
  const target = e.target as Element;
  return (
    // Adjust the offset to account for the scrollbar padding
    e.nativeEvent.offsetX + 9 > target.clientWidth ||
    e.nativeEvent.offsetY > target.clientHeight
  );
};
